import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';
import { MultiDocPostBody } from '../models/review/multi-doc-post-body';
import { Custodian } from '../models/review/custodian.model';
import { MultiDocGroup } from 'src/app/models/field/multi-doc-field.model';

@Injectable({
  providedIn: 'root'
})
export class MultiDocFieldService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

  getMultiDocFields(): Observable<MultiDocGroup[]> {
    return this.http.get<MultiDocGroup[]>(`${this.appConfigService.getConfig().webApi}/api2/multi-doc-fields`)
      .pipe(catchError(this.errorHandler.handleError<MultiDocGroup[]>(`get multi-doc fields`)));
  }

  getCustodianListForMultiDocEdit(): Observable<Custodian[]> {
    return this.http.get<Custodian[]>(`${this.appConfigService.getConfig().webApi}/api2/multi-doc-fields/custodians`)
      .pipe(catchError(this.errorHandler.handleError<Custodian[]>(`get multi-doc fields`)));
  }

  saveMultiDocField(body: MultiDocPostBody): Observable<boolean> {
    return this.http.post<boolean>(`${this.appConfigService.getConfig().webApi}/api2/multi-doc-fields`, body)
      .pipe(catchError(this.errorHandler.handleError<boolean>(`save multi-doc fields`)));
  }
}
